import React from 'react'
import {
  Box
} from "@mui/material";
import { Link } from 'react-router-dom';


const Footer = () => {
    return (
        <>
            <img
                src={"or.svg"}
                alt="Or"
                style={{ marginBottom: '24px' }}
            />

            <Box
                sx={{
                    mt: '0px',
                    color: '#fff',
                    fontSize: '16px',
                    fontWeight: 500,
                }}
                className='forgotPass'
            >
                Back to <Link to="/login">Login</Link> Page
            </Box>
        </>
    )
}

export default Footer